// extracted by mini-css-extract-plugin
export default {"subpage":"subpage_subpage__-B6aI","subheader":"subpage_subheader__FfyLz","illustration":"subpage_illustration__gjVOw","tile":"subpage_tile__Pn+LA"};